import { render, staticRenderFns } from "./CreateProforma.vue?vue&type=template&id=345d3741&"
import script from "./CreateProforma.vue?vue&type=script&lang=js&"
export * from "./CreateProforma.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports